<template>
  <div class="error-content">
    <div class="error-content__title">
      {{ $t('Errors.PageNotFound') }}
    </div>
    <div
      class="ml-4 pt-4 pb-4 text-left h4-headline opacity-7">
      {{ $t('Errors.PageNotFoundText') }}
    </div>
    <div
      class="error-content_btns"
      :description="description">
      <sButton
        class="error-content_btn"
        :to="{ name: 'homePage' }">
        {{ $t('Errors.ToHomePage') }}
      </sButton>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error404',
  data() {
    return {
      route: {}
    }
  },
  computed: {
    description() {
      return this.$route?.params?.descript
    }
  },
}
</script>
<style lang="scss" scoped>
.error-content {
  &__title {
    text-align: left;
    margin-left: 16px;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    @media (max-width:935px) {
      margin-left: 0;
      text-align: center;
    }
  }
  &_btns {
    margin-left: 16px;
    margin-top: 16px;
    display: flex;
    @media (max-width:935px) {
      display: grid;
      row-gap: 20px;
      max-width: 100%;
    }
  }
  &_btn {
    @media (max-width:935px) {
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: 100%;
      width: 300px;
    }
  }
}
</style>
